import BehaviorOperandTypes from '../../constants/behavior_operand_types';

import EnumValidator from 'validator/enum_validator';

export default class BehaviorOperand {
	_type;

	constructor(props = {}) {
		Object.keys(props)
			.forEach((propName) => this[propName] = props[propName]);
	}

	get type() {
		return this._type;
	}

	set type(value) {
		EnumValidator.validate(value, BehaviorOperandTypes);
		this._type = BehaviorOperandTypes[value];
	}
}
